/**
 * Builds an array of user selected macros in the URL and Body
 * @param {*} value1 a string value that may contain macros to combine with value2, the "URL" must use value1
 * @param {*} value2 a string value that may contain macros to combine with value1, the "Body" must use value2
 * @param {*} macros an array of current macros
 * @returns an array of user selected macros
 */

export function buildMacros(value1, value2, macros) {
  const string1 = JSON.stringify(value1);

  try {
    // If the value is valid json, it will parse down
    value2 = buildMacroStringFromBody(JSON.parse(value2));
  } catch {
    // when value is not valid JSON, don't send it to the next step, or the tags will look weird
    value2 = '';
  }

  const string2 = value2;
  const newValue = string1 + string2;
  if (newValue) {
    // Regex for detecting macros in url
    const macrosRegex = /\[(.*?)\]/g;

    // Initialize a source array, all the current macros in the url
    const sourceMacros = [];

    newValue.match(macrosRegex)?.forEach(macro => {
      sourceMacros.push({ name: macro, value: '' });
    });
    

    // Filter the prevoiusly set local url macros data
    const updatedUrlMacros = macros.filter(tm => {
      return sourceMacros.some(sm => sm.name === tm.name);
    });

    // Add new macros from the currently available source array to local data
    sourceMacros.forEach(sm => {
      const foundTargetMacro = updatedUrlMacros.find(tm => tm.name === sm.name);
      if (!foundTargetMacro) {
        updatedUrlMacros.push({ name: sm.name, value: '' });
      }
    });

    return updatedUrlMacros;
  }
  return [];
}

function buildMacroStringFromBody(jsonBody) {
  let macroString = '';
  const macrosRegex = /\[(.*?)\]/g;

  if (typeof (jsonBody) === 'string') {
    if (jsonBody.match(macrosRegex)) {
      macroString += jsonBody;
    }
  } else if (Array.isArray(jsonBody)) {
    jsonBody.forEach(item => { macroString += buildMacroStringFromBody(item) })
  } else if (typeof (jsonBody) === 'object' && jsonBody !== null) { 
    for (const [key, value] of Object.entries(jsonBody)) {
      macroString += buildMacroStringFromBody(value);
    }
  }

  return macroString;
}